import type { Wallet } from '@wallet-standard/base';
import type {
  SignAndSendTransactionFeature,
  SignMessageFeature,
  SignTransactionFeature,
} from '@wallet-standard/experimental-features';
import type {
  StandardConnectFeature,
  StandardDisconnectFeature,
  StandardEventsFeature,
} from '@wallet-standard/features';

type WalletStandardFeatures = {
  'solana:signAndSendTransaction': SignAndSendTransactionFeature['experimental:signAndSendTransaction'];
  'solana:signMessage': SignMessageFeature['experimental:signMessage'];
  'solana:signTransaction': SignTransactionFeature['experimental:signTransaction'];
} & StandardConnectFeature &
  Partial<StandardDisconnectFeature> &
  StandardEventsFeature;

export const getFeaturesForSolanaStandardWallet = (wallet: Wallet) => {
  return wallet.features as WalletStandardFeatures;
};
